import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Pannello (`rounded-3xl`): contenitore ampio, per esempio i moduli delle pagine pubbliche. */
@Component({
  selector: 'bs-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `
    <section
      class="rounded-3xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8 dark:border-stone-800 dark:bg-stone-900"
      [attr.aria-labelledby]="labelledBy()"
      [attr.data-testid]="testId()"
    >
      <ng-content />
    </section>
  `,
})
export class PanelComponent {
  readonly labelledBy = input<string | null>(null);
  readonly testId = input<string | null>(null);
}
